import { Editor } from '@tinymce/tinymce-react'

// core + UI
import 'tinymce/tinymce'
import 'tinymce/icons/default'
import 'tinymce/themes/silver'
import 'tinymce/models/dom/model'

// plugins you use
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/image'

// skins (CSS) – bundled by Vite
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/content/default/content.min.css'

// Props
type RteProps = {
    value?: string
    onChange: (html: string) => void
    disabled?: boolean
    placeholder?: string
    id?: string
}

export default function RichTextEditor({ value = '', onChange, disabled = false, placeholder, id }: RteProps) {
    return (
        <Editor
            id={id}
            init={{
                menubar: false,
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | image | code | help',
                browser_spellcheck: true,
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                height: 420,
                skin: false,
                content_css: false,
                placeholder: placeholder,
            }}
            value={value}
            onEditorChange={onChange}
            disabled={disabled}
            licenseKey='gpl'
        />
    )
}
